module.exports = __webpack_public_path__ + "cd455783/img/pdf-icon.79f04a36.svg";